if (!customElements.get('localization-combined-selector')) {
  customElements.define(
    'localization-combined-selector',
    class LocalizationCombinedSelector extends HTMLElement {
      constructor() {
        super();

        const mapScript = this.querySelector('script[data-language-map]');
        this.list = this.querySelector('[data-language-list]');

        // No per-country language map (single country, or language switching
        // unavailable) means nothing to rebuild — leave the static markup as-is.
        if (!mapScript || !this.list) return;

        try {
          this.languagesByCountry = JSON.parse(mapScript.textContent);
        } catch (error) {
          return;
        }

        // The server already renders the correct language list for the current
        // country, so only rebuild in response to an actual country change.
        this.addEventListener('change', this.onChange.bind(this));
      }

      onChange(event) {
        if (event.target.name === 'country_code') {
          this.renderLanguages(event.target.value);
        }
      }

      renderLanguages(countryCode) {
        const languages = this.languagesByCountry[countryCode];
        if (!languages || !languages.length) return;

        // Preserve the current language if the new country still offers it,
        // otherwise fall back to that country's first (primary) language.
        const currentlyChecked = this.list.querySelector('input[name="locale_code"]:checked');
        const previous = currentlyChecked ? currentlyChecked.value : null;
        const selected = languages.some((language) => language.value === previous) ? previous : languages[0].value;

        this.list.innerHTML = languages.map((language) => this.buildItem(language, language.value === selected)).join('');
      }

      buildItem(language, checked) {
        return `<li class="disclosure__item" tabindex="-1">
          <label class="radio-button${checked ? ' radio-button--active' : ''}">
            <input
              type="radio"
              name="locale_code"
              value="${language.value}"
              class="radio-button__input"
              tabindex="0"
              ${checked ? 'checked' : ''}
            >
            <span class="radio-button__indicator"></span>
            <span class="radio-button__text link-m-suisse">${language.label}</span>
          </label>
        </li>`;
      }
    }
  );
}
